import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useLocation, useNavigate } from "react-router-dom";
import { Container } from "@mui/material";
import logo from "./../../assets/safe_logo.png";
import CustomLoader from "../../components/CustomLoader";
import RoundButton from "../../components/RoundButton";
import { useDispatch, useSelector } from "react-redux";
import { resendVerificationEmailRequest } from "../../redux/signup/action";
import { sendEmailForgotPassword } from "../../redux/forgotPassword/action";
import background_image from "./../../assets/png/background_image.png";
import { useResponsive } from "../../hooks/useResponsive";
import {
  updateCompanyDetailsFrom,
  updateSignUpFrom,
} from "../../redux/signup/constants";
import { useTranslation } from "react-i18next";

const EmailVerificationPage = () => {
  const { isLoading, signUpData } = useSelector((state) => state.signUpReducer);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation();

  const smDown = useResponsive("down", "sm");
  const userEmail = location?.state?.user?.userEmail
    ? location?.state?.user?.userEmail
    : location?.state?.entity_email;

  const urlParams = new URLSearchParams(decodeURIComponent(location.search));
  const resendUserId = urlParams.get("id");
  const resendUserEmail = urlParams.get("email");

  const onSubmitApiCall = () => {
    if (
      (userEmail && location?.state?.entity_user_status === "ACTIVE") ||
      location?.state?.user?.userStatus === "ACTIVE"
    ) {
      dispatch(sendEmailForgotPassword({ email: userEmail }, (data) => {}));
    } else if (
      (userEmail && location?.state?.entity_user_status === "INACTIVE") ||
      location?.state?.user?.userStatus === "INACTIVE"
    ) {
      const data = {
        email: location?.state?.user?.userEmail
          ? location?.state?.user?.userEmail
          : location?.state?.entity_email,
        userId: location?.state?.user?.userId
          ? location?.state?.user?.userId
          : location?.state?.entity_id,
      };
      dispatch(
        resendVerificationEmailRequest(data, (res) => {
          if (res?.message) {
          }
        }),
      );
    } else {
      const data = {
        email: signUpData?.user?.userEmail || resendUserEmail,
        userId: signUpData?.user?.userId || resendUserId,
      };
      dispatch(
        resendVerificationEmailRequest(data, (res) => {
          if (res?.message) {
          }
        }),
      );
    }
  };

  return (
    <Container
      disableGutters
      maxWidth={false}
      style={{
        paddingTop: 20,
        position: "relative",
        minHeight: "100vh",
        backgroundColor: "#80BCFF4F",
        backgroundImage: `url(${background_image})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        width: "100vw",
        height: "100vh",
      }}
    >
      <Box
        maxWidth="xs"
        sx={{
          height: 1,
          flexGrow: 1,
          minHeight: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            height: 1,
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            flexDirection: ["column", "column", "row"],
          }}
        >
          <Stack
            alignItems="center"
            justifyContent="center"
            sx={{ height: 1, width: 1, padding: 0, gap: 5 }}
          >
            <img src={logo} alt="Your Alt Text" />
            <Card
              sx={{
                p: 3,
                width: 1,
                maxWidth: 600,
                height: smDown ? 1 : "auto",
              }}
            >
              <Stack>
                <Typography variant="titleText" color="primary.main">
                  {location?.state?.isForgotPasswordVerify
                    ? t("pages.forgotPassword.pageHeading")
                    : t("pages.forgotPassword.text01")}
                </Typography>
                <Stack
                  spacing={3}
                  alignItems="center"
                  justifyContent="center"
                  sx={{ mt: 3 }}
                >
                  <Typography
                    variant="emailDescriptionText"
                    color="common.lightblack"
                    alignItems="center"
                    justifyContent="center"
                  >
                    {`${t("pages.forgotPassword.text02")} ${
                      userEmail
                        ? userEmail
                        : signUpData?.user?.userEmail || resendUserEmail
                    } . ${t("pages.forgotPassword.text03")}.`}
                  </Typography>
                </Stack>
              </Stack>
              <RoundButton
                sx={{ mt: 8, mb: 2 }}
                size="large"
                fullWidth
                variant="contained"
                type="submit"
                color="primary"
                rounded
                onClick={() => {
                  onSubmitApiCall();
                }}
              >
                <Typography variant="buttonText" color="common.buttonText">
                  {t("pages.forgotPassword.text04")}
                </Typography>
              </RoundButton>
              <Stack spacing={3} alignItems="center" justifyContent="center">
                <Typography
                  sx={{ textDecoration: "underline", cursor: "pointer" }}
                  color="primary.main"
                  variant="smallLinkText"
                  underline="hover"
                  onClick={() => {
                    dispatch(updateSignUpFrom({}));
                    dispatch(updateCompanyDetailsFrom({}));
                    navigate("/signup");
                  }}
                >
                  {t("pages.forgotPassword.text05")}
                </Typography>
                {!location?.state?.user?.userEmail && (
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Typography
                      variant="emailDescriptionText"
                      color="common.lightblack"
                      alignItems="center"
                      justifyContent="center"
                    >
                      {t("pages.forgotPassword.text06")}
                    </Typography>
                    <Typography
                      sx={{ marginLeft: "5px", cursor: "pointer" }}
                      color="primary.main"
                      variant="smallLinkText"
                      underline="hover"
                      onClick={() => {
                        navigate("/signup", {
                          state: {
                            newUser: true,
                          },
                        });
                      }}
                    >
                      {t("pages.forgotPassword.text07")}
                    </Typography>
                  </Stack>
                )}
              </Stack>
            </Card>
          </Stack>
        </Box>
      </Box>
      {isLoading && <CustomLoader />}
    </Container>
  );
};

export default EmailVerificationPage;
